export const MATERIALS = [
  { key: "wood",    name: "Walnut Wood",       bg: "url('/materials/walnut-surface.png')" },
  { key: "metal",   name: "Brushed Metal",     bg: "url('/materials/brass-surface.png')" },
  { key: "slate",   name: "Natural Slate",     bg: "url('/materials/slate-surface.png')" },
  { key: "leather", name: "Full-Grain Leather", bg: "url('/materials/leather-surface.png')" },
];

export const FONTS = [
  { key: "serif", label: "Cormorant Garamond", family: "'Cormorant Garamond', serif" },
  { key: "sans", label: "Manrope", family: "'Manrope', sans-serif" },
  { key: "mono", label: "Monospaced", family: "ui-monospace, Menlo, monospace" },
  { key: "script", label: "Script", family: "'Cormorant Garamond', serif", italic: true },
];

export const clampFrac = (v) => Math.max(0.05, Math.min(0.95, v));
